import React from 'react'
import { Link } from 'react-router-dom'

export default function AuthLayout({ children }) {
  return (
    <div className="flex flex-col min-h-screen font-sans text-[var(--text-primary)] overflow-hidden bg-gradient-to-b from-[var(--bg-start)] to-[var(--bg-end)]">
      {/* Header - Fixed position with high z-index */}
      <header className="fixed top-0 left-0 right-0 w-full flex justify-between items-center p-4 md:px-10 bg-[var(--accent-secondary)] shadow-md z-[9999]">
        <Link to="/" className="flex items-center">
          <img src="/images/logo.png" alt="Toritech Logo" className="w-8 h-8 mr-2" />
          <h1 className="text-xl md:text-3xl font-bold tracking-wide text-white">Toritech</h1>
        </Link>
        <div className="flex gap-2 md:gap-4">
          <Link 
            to="/login" 
            className="px-3 md:px-4 py-1.5 md:py-2 text-sm font-medium border border-white rounded hover:bg-[var(--hover-light)] active:bg-[var(--hover-light)] focus:bg-[var(--hover-light)] transition-all duration-200 whitespace-nowrap text-white"
          >
            Login
          </Link>
          <Link 
            to="/signup" 
            className="px-3 md:px-4 py-1.5 md:py-2 text-sm font-medium bg-[var(--accent-primary)] text-[var(--btn-text-on-accent)] rounded hover:bg-[var(--hover-dark)] active:bg-[var(--accent-primary)] focus:bg-[var(--accent-primary)] transition-all duration-200 whitespace-nowrap"
          >
            Sign Up
          </Link>
        </div>
      </header>

      {/* Main content area with proper spacing */}
      <div className="flex min-h-screen w-full items-center justify-center px-4 py-16 sm:py-24">
        <div className="w-full max-w-md">
          {children}
        </div>
      </div>
    </div>
  )
} 